/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Which check-in version to use
 */
export enum FinnairCheckInVersion {
  LEGACY = 'LEGACY',
  NEXTGEN = 'NEXTGEN'
}

